<fieldset class="fieldGroup">
  <legend>Rating Output</legend>
  <div class="ratingsOutputPanel">
    <div class="detailRow">
      <label class="displayLabel">Airflow:</label>
      <label class="displayValue">{{ response().Airflow }}</label>
      <label class="configurationRatingUnitLabel">{{ getAirflowUnits() }}</label>
      @if (response().CircuitResponse?.OutputPower) {
        <span>
          <label class="displayLabel">Power:</label>
          <label class="displayValue">{{ response().CircuitResponse.OutputPower }}</label>
          <label class="configurationRatingUnitLabel">Watts</label>
        </span>
      }
      @if (response().CircuitResponse?.HorsepowerValue) {
        <span>
          <label class="displayLabel">BHP:</label>
          <label class="displayValue">{{ response().CircuitResponse.HorsepowerValue }}</label>
        </span>
      }
      @if (response().CircuitResponse?.FullLoadAmps) {
        <span>
          <label class="displayLabel">FLA:</label>
          <label class="displayValue">{{ response().CircuitResponse.FullLoadAmps }}</label>
        </span>
      }
    </div>
    <div>
      @if (response()?.PrimaryCoilResponse) {
        <div class="ratingsOutputPanel">
          <app-coil-response [title]="'Primary Response'" [coilResponse]="response().PrimaryCoilResponse"
            [metricInput]="metricInput()" [isSureflow]="isSureflow()">
          </app-coil-response>
        </div>
      }
      @if (response()?.SecondaryCoilResponse || response()?.ElectricHeatResponse) {
        <div class="ratingsOutputPanel">
          @if (response()?.SecondaryCoilResponse) {
            <div>
              <app-coil-response [title]="'Secondary Response'" [coilResponse]="response().SecondaryCoilResponse"
                [metricInput]="metricInput()" [isSureflow]="isSureflow()">
              </app-coil-response>
            </div>
          }
          @if (response()?.ElectricHeatResponse) {
            <div>
              <app-coil-response [title]="'E-Heat Response'" [coilResponse]="response().ElectricHeatResponse"
                [metricInput]="metricInput()">
              </app-coil-response>
            </div>
          }
        </div>
      }
    </div>
    <div>
      @if (response()?.PrimaryDrivePackage) {
        <div class="ratingsOutputPanel">
          <app-schedule-line-drive-package [fieldLabel]="'Primary Drive Package'"
            [response]="response().PrimaryDrivePackage">
          </app-schedule-line-drive-package>
        </div>
      }
      @if (response()?.SecondaryDrivePackage) {
        <div class="ratingsOutputPanel">
          <app-schedule-line-drive-package [fieldLabel]="'Alternate Drive Package'"
            [response]="response().SecondaryDrivePackage">
          </app-schedule-line-drive-package>
        </div>
      }
    </div>
  </div>
</fieldset>
